import React from 'react';
import {SelectMultiple} from 'tea-component';
import './index.scss';

function MultipleSelector(props) {
  const {label = '', options = [], value, onChange, button, className='', ...reset} = props;
  return (
    <SelectMultiple
      className={`dbl-multiple-selector ${className}`}
      options={options}
      staging={false}
      appearance="button"
      matchButtonWidth
      value={value}
      onChange={onChange}
      button={(selectedOptions) => {
        const text = button(selectedOptions);
        return (<>
          <span className={'label'}>{label}</span>
          {text}
        </>);
      }}
      {...reset}
    />
  );
}

export default MultipleSelector;